var a=[{id:10,name:"10",value:10},{id:20,name:"20",value:20},{id:50,name:"50",value:50},{id:100,name:"100",value:100}];export{a as PAGE_SIZES};
//# sourceMappingURL=PaginationPageJumper.constants.js.map
